import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { storage } from "./firebase/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { message } from "antd";
import axios from "axios";
import logo from "./logo.png";

export const generatePDF = async (formData, imageBase64,step1Data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.width;
      const margin = 20;
      const maxWidth = pageWidth - margin * 2;
      let finalY = 30; // Adjusted to start content below header

      // Logo Positioning
      const logoWidth = 30;
      const logoHeight = 30;
      const logoX = 13; // Centered horizontally with some left margin
      const logoY = 5; // Positioned closer to the top
      doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

      // Title Positioning (Next to Logo)
      const titleX = margin + logoWidth + 10; // Adjust title position based on logo width
      const titleY = 18; // Vertically aligned with logo
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text("Vehicle Registration", titleX, titleY+5);

      finalY += 5; // Adjust spacing after header

      // Add Table
      const tableData = Object.entries(formData).map(([question, answer]) => {
        const textValue = String(answer);
        return [question, textValue.startsWith("http") ? "" : textValue];
      });

     
      autoTable(doc, {
        head: [["Question", "Response"]],
        body: tableData,
        startY: finalY,
        styles: { fontSize: 10, cellWidth: "wrap" },
        headStyles: {
          fillColor: "#d68028",
          textColor: "#ffffff",
          fontStyle: "bold",
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: maxWidth - 60 },
        },
        didDrawCell: function (data) {
          if (data.column.index === 1) {
              const text = String(formData[data.row.raw[0]]);
              if (text.startsWith("http")) {
                  doc.setTextColor(0, 0, 255);
                  doc.textWithLink("Link", data.cell.x + 2, data.cell.y + 5, { url: text,maxWidth:maxWidth-60, });
                  doc.setTextColor(0, 0, 0);
              }
          }
      },
        didDrawPage: function (data) {
          finalY = data.cursor.y; // Track final Y after table
        },
      });

      finalY += 40;

      // Function to add contract sections with auto page breaks
      const addSection = (title, content, isList = false) => {
        const lineHeight = 6;

        if (finalY + 10 > doc.internal.pageSize.height - 20) {
          doc.addPage();
          finalY = 15; // Move to top on new page
        }

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(title, margin, finalY);
        finalY += 8;

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        if (isList) {
          content.forEach((item) => {
            if (finalY + lineHeight > doc.internal.pageSize.height - 20) {
              doc.addPage();
              finalY = 15;
            }
            doc.text(`• ${item}`, margin + 5, finalY);
            finalY += lineHeight;
          });
        } else {
          const wrappedText = doc.splitTextToSize(content, maxWidth);
          wrappedText.forEach((line) => {
            if (finalY + lineHeight > doc.internal.pageSize.height - 20) {
              doc.addPage();
              finalY = 15;
            }
            doc.text(line, margin, finalY);
            finalY += lineHeight;
          });
        }

        finalY += 6;
      };

      // Add Contract Content
      addSection("Opera Taxis Operator Compliance Contract", 
        "This Contract is entered into between Opera Taxis (the 'Network') and [Registered Owner of the Taxi] (the 'Operator').");

      addSection("1. Purpose",
        "The purpose of this Contract is to ensure that the Operator fully complies with all relevant policies and procedures established by Opera Taxis.");

      addSection("2. Operator Obligations", [
        "Comply with all Opera Taxis policies and procedures,including but not limited to:",
        "Complaint Handling Procedure",
        "Drug and Alcohol Policy",
        "Fatigue Management Policy",
        "Incident Management Policy",
        "Network By-Laws",
        "Safety Management System (SMS)",
        "Vehicle Maintenance and Roadworthiness Policy",
      ], true);

      addSection("3. Policy Compliance", [
        "Complaint Handling: Ensure complaints are handled promptly and professionally.",
        "Drug and Alcohol Policy: Maintain a zero-tolerance approach to drug and alcohol use.",
        "Fatigue Management: Monitor driver fatigue and ensure compliance with regulations.",
        "Incident Management: Respond effectively to incidents with immediate reporting.",
        "Network By-Laws: Follow all conduct rules, including insurance and vehicle safety.",
        "Safety Management: Implement measures to ensure the safety of passengers, drivers, and the public.",
        "Vehicle Maintenance: Conduct regular maintenance and keep safety records.",
      ], true);

      addSection("4. Reporting and Record Keeping", [
        "Maintain accurate records required by Opera Taxis policies.",
        "Submit reports including incident reports, maintenance logs, and checklists.",
        "Cooperate with audits or inspections by Opera Taxis or regulatory authorities.",
      ], true);

      addSection("5. Non-Compliance and Consequences", 
        "Failure to comply with this Contract may result in disciplinary action, including suspension or termination.");

      addSection("6. Amendments", 
        "Opera Taxis reserves the right to update this Contract and related policies. Operators will be notified of any changes.");

      addSection("7. Governing Law", 
        "This Contract is governed by the laws of New South Wales, Australia.");

      addSection("8. Unpaid Dues and Collections", 
        "If any amount remains unpaid, Opera Taxis may engage credit collection agencies to recover outstanding funds.");

      addSection("9. Driver Fine Liability", 
        "If an overcharged fine amount is due from a driver, the Operator will be equally responsible if the driver fails to reimburse.");

      addSection("10. Acknowledgment and Signature", 
        "By signing this Contract, the Operator acknowledges they have read, understood, and agreed to abide by all terms.");

        const currentDate = new Date().toLocaleDateString(); // Get current date

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(`Operator Name: ${step1Data.ownerName}`, margin, finalY);
      finalY += 10;
      doc.text(`Date: ${currentDate}`, margin, finalY);
      
      finalY += 10;
      doc.text(`Sign:`, margin, finalY);
      // Add Operator's Image (Signature or Picture)
      if (imageBase64) {
        const imageWidth = 100;
        const imageHeight = 40;
        if (finalY + imageHeight + 10 > doc.internal.pageSize.height - 20) {
          doc.addPage();
          finalY = 15;
        }
        doc.addImage(imageBase64, "PNG", margin, finalY + 10, imageWidth, imageHeight);
        finalY += imageHeight + 20;
      }

      // Convert to Blob & Upload to Firebase
      const pdfBlob = doc.output("blob");
      const storageRef = ref(storage, `${step1Data.ownerName}-${Date.now()}.pdf`);
      await uploadBytes(storageRef, pdfBlob);
      const pdfUrl = await getDownloadURL(storageRef);

      resolve(pdfUrl);
    } catch (error) {
      reject(error);
    }
  });
};

export const sendEmail = async (email, formResponse) => {
  try {
    const apiKey =
      "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"; // Replace with your SendinBlue API key
    const senderEmail = "Info@operataxis.com"; // Replace with your sender email address
    const senderName = "Opera Taxis"; // Replace with your sender nam
    const response = await axios.post(
      "https://api.sendinblue.com/v3/smtp/email",
      {
        sender: { name: senderName, email: senderEmail },
        to: [{ email: email }],
        subject: "Welcome to Opera Taxis !",
        htmlContent: `
          <!DOCTYPE html>
          <html lang="en">
          <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Welcome Email</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            background-color: #f9f9f9;
            padding: 20px;
          }
          .container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          }
          h1 {
            color: #333;
          }
          p {
            margin-bottom: 10px;
          }
          .message {
            background-color: #f3f3f3;
            padding: 15px;
            border-radius: 5px;
          }
          .footer {
            margin-top: 20px;
            text-align: center;
          }
        </style>
          </head>
          <body>
        <div class="container">
          <h1>Welcome to Opera Taxis !</h1>
          <div class="message">
            <p>Vehicle Registration Form</p>
            <p>Thank you for submitting your documents. We are currently reviewing them and will let you know if anything else is needed.</p>
            <p>You can view your vehicle registration form through the link below:
            </p>
            <p><a href="${formResponse}" target="_blank">View Form</a></p>
          </div>
          <p>If you have any questions or need assistance, feel free to reach out to our support team.
          </p>
          <p>
          Kind regards,<br/>
          Opera Taxis Team<br/>
          1300 088 544<br/>
          <div class="footer">
          </div>
        </div>
          </body>
          </html>
            `,
      },
      {
        headers: {
          "api-key": apiKey,
          "Content-Type": "application/json",
        },
      }
    );
    message.success("Email sent successfully:");
    console.log("Email sent successfully:", response.data);
  } catch (error) {
    message.error(error.message);
    console.error("Error sending email:", error.message);
  }
};
